// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37ZOq","col":"styles_col__3FCGk"};